export const SALE_PRODUCT_REVIEW_REASON_LABELS = {
  COMPONENT_INACTIVE: "Un componente está inactivo.",
  COMPONENT_DELETED: "Un componente fue eliminado.",
  MISSING_ACTIVE_RECIPE_VERSION: "Falta una versión activa válida de receta.",
  MISSING_PURCHASE_ITEM: "Falta seleccionar un ítem de compra.",
  MISSING_PURCHASE_ITEM_SELECTION: "Falta seleccionar un ítem de compra.",
  AUTOMATIC_COST_PENDING: "El costo automático todavía no fue calculado.",
  AUTOMATIC_COST_RECALCULATION_FAILED:
    "No se pudo actualizar automáticamente el costo estimado.",
  ACTIVATION_VALIDATION_FAILED: "La validación de activación detectó cambios.",
  INGREDIENT_INACTIVE: "Un insumo utilizado está inactivo.",
  INGREDIENT_DELETED: "Un insumo utilizado fue eliminado.",
  INGREDIENT_UNIT_CHANGED: "Cambió la unidad de un insumo utilizado.",
  PURCHASE_ITEM_INACTIVE: "Un ítem de compra seleccionado está inactivo.",
  PURCHASE_ITEM_DELETED: "Un ítem de compra seleccionado fue eliminado.",
  PURCHASE_ITEM_INGREDIENT_CHANGED: "Un ítem seleccionado cambió de insumo.",
  SUPPLIER_INACTIVE: "El proveedor de un ítem seleccionado está inactivo.",
  RECIPE_CHANGED: "Una receta utilizada cambió.",
  RECIPE_INACTIVE: "Una receta utilizada está inactiva.",
  RECIPE_DELETED: "Una receta utilizada fue eliminada.",
  RECIPE_VERSION_CHANGED: "La versión de una receta utilizada cambió.",
  PREPARED_PRODUCT_CHANGED: "Un elaborado utilizado cambió.",
  PREPARED_PRODUCT_INACTIVE: "Un elaborado utilizado está inactivo.",
  PREPARED_PRODUCT_DELETED: "Un elaborado utilizado fue eliminado.",
  PREPARED_RECIPE_CHANGED: "Cambió la composición de un elaborado utilizado.",
};

export const SALE_PRODUCT_COST_STATUS_LABELS = {
  VALID: "Válido (histórico)",
  ESTIMATED: "Estimado",
  INCOMPLETE: "Estimación incompleta",
  UNAVAILABLE: "Sin costo estimado",
  REQUIRES_REVIEW: "Requiere revisión",
};

export function saleProductCostStatusLabel(status) {
  return SALE_PRODUCT_COST_STATUS_LABELS[status] || "Pendiente";
}

export function isSaleProductCostUsable(status) {
  return status === "VALID" || status === "ESTIMATED";
}

export function saleProductReviewReasonLabel(reason) {
  return SALE_PRODUCT_REVIEW_REASON_LABELS[reason] || String(reason || "");
}

export function saleProductReviewReasonsLabel(reasons, separator = " • ") {
  return Array.from(new Set(Array.isArray(reasons) ? reasons : []))
    .map(saleProductReviewReasonLabel)
    .filter(Boolean)
    .join(separator);
}
